import { createReducer } from '@reduxjs/toolkit';

import { inviteFriendsFailure, inviteFriendsRequest, inviteFriendsSuccess } from './inviteActions';

export type InviteState = {
	loading: boolean;
	error?: string | null;
	lastRecipientIds: string[];
};

const initialState: InviteState = {
	loading: false,
	error: null,
	lastRecipientIds: [],
};

export const inviteReducer = createReducer(initialState, b => {
	b.addCase(inviteFriendsRequest, s => {
		s.loading = true;
		s.error = null;
	});

	b.addCase(inviteFriendsSuccess, (s, a) => {
		s.loading = false;
		s.lastRecipientIds = a.payload.recipientIds;
	});

	b.addCase(inviteFriendsFailure, (s, a) => {
		s.loading = false;
		s.error = a.payload;
	});
});

export default inviteReducer;
